const Flickity = require('flickity');

function initFlickity(){
    
	var flkty = new Flickity( '.c-doctors-carrousel', {
		pageDots: false
	});
	var galleryCells = $('.c-doctors-carrousel').find('.c-doctors-card');
	if ( galleryCells.length < 2 ) {
		$('.c-doctors-carrousel').addClass('is-one-item');
	}
	var progressBar = $('.c-doctors-carrousel-progress').find('.c-progress-bar');

	flkty.on( 'scroll', function( progress ) {

		progress = Math.max( 0, Math.min( 1, progress ) );
		progressBar.css('width', progress * 100 + '%');

	});

}

module.exports = {
	initFlickity
};